import CONFIG from "../configurations/config";

/**
 * 🔹 Get Parent Folder
 */
export const getParentFolder = async (groupId, setError) => {
  console.log("📁 [getParentFolder] called with groupId:", groupId);

  try {
    const url = `${CONFIG.PORTAL_URL}/o/headless-delivery/v1.0/sites/${groupId}/document-folders`;
    console.log("🌐 [getParentFolder] URL:", url);

    const rootRes = await fetch(url, {
      headers: { Accept: "application/json",
        Authorization: "Basic " + btoa(`${CONFIG.USER_NAME}:${CONFIG.PASSWORD}`)
       }
    });

    console.log(
      "📡 [getParentFolder] HTTP Status:",
      rootRes.status,
      rootRes.statusText
    );

    const rootData = await rootRes.json();
    console.log("📦 [getParentFolder] Response JSON:", rootData);

    if (!Array.isArray(rootData.items)) {
      console.error(
        "❌ [getParentFolder] items is not an array:",
        rootData.items
      );
      setError("Cannot access root folders (check Guest permissions)");
      return null;
    }

    console.log(
      "📂 [getParentFolder] Available folders:",
      rootData.items.map(f => f.name)
    );

    const statesPdfFolder = rootData.items.find(
      f => f.name === CONFIG.PARENT_FOLDER_NAME
    );

    console.log(
      "🎯 [getParentFolder] Matched parent folder:",
      statesPdfFolder
    );

    if (!statesPdfFolder) {
      setError(`Folder "${CONFIG.PARENT_FOLDER_NAME}" not found`);
      return null;
    }

    return statesPdfFolder;
  } catch (e) {
    console.error("🔥 [getParentFolder] Exception:", e);
    setError("Network error while fetching parent folder");
    return null;
  }
};

/**
 * 🔹 Get Child Folder
 */
export const getChildFolder = async (statesPdfFolder, matchedConfig, setError) => {
  console.log("📂 [getChildFolder] called with:", {
    parentFolderId: statesPdfFolder?.id,
    expectedFolder: matchedConfig?.documentFolder
  });

  try {
    const url = `${CONFIG.PORTAL_URL}/o/headless-delivery/v1.0/document-folders/${statesPdfFolder.id}/document-folders`;
    console.log("🌐 [getChildFolder] URL:", url);

    const childRes = await fetch(url, {
     headers: { Accept: "application/json",
        Authorization: "Basic " + btoa(`${CONFIG.USER_NAME}:${CONFIG.PASSWORD}`)
       }
    });

    console.log(
      "📡 [getChildFolder] HTTP Status:",
      childRes.status,
      childRes.statusText
    );

    const childData = await childRes.json();
    console.log("📦 [getChildFolder] Response JSON:", childData);

    if (!Array.isArray(childData.items)) {
      console.error(
        "❌ [getChildFolder] items is not an array:",
        childData.items
      );
      setError("Cannot access state folders");
      return null;
    }

    console.log(
      "📂 [getChildFolder] Available state folders:",
      childData.items.map(f => f.name)
    );

    const stateFolder = childData.items.find(
      f => f.name === matchedConfig.documentFolder
    );

    console.log(
      "🎯 [getChildFolder] Matched state folder:",
      stateFolder
    );

    if (!stateFolder) {
      setError(`State folder "${matchedConfig.documentFolder}" not found`);
      return null;
    }

    return stateFolder;
  } catch (e) {
    console.error("🔥 [getChildFolder] Exception:", e);
    setError("Network error while fetching state folder");
    return null;
  }
};

/**
 * 🔹 Get Documents
 */
export const getDocuments = async (stateFolder, setError) => {
  console.log("📄 [getDocuments] called with folderId:", stateFolder?.id);

  try {
    const url = `${CONFIG.PORTAL_URL}/o/headless-delivery/v1.0/document-folders/${stateFolder.id}/documents`;
    console.log("🌐 [getDocuments] URL:", url);

    const docsRes = await fetch(url, {
       headers: { Accept: "application/json",
        Authorization: "Basic " + btoa(`${CONFIG.USER_NAME}:${CONFIG.PASSWORD}`)
       }
    });

    console.log(
      "📡 [getDocuments] HTTP Status:",
      docsRes.status,
      docsRes.statusText
    );

    const docsData = await docsRes.json();
    console.log("📦 [getDocuments] Response JSON:", docsData);

    if (!Array.isArray(docsData.items)) {
      console.warn(
        "⚠️ [getDocuments] No documents array found:",
        docsData.items
      );
    }

    return docsData;
  } catch (e) {
    console.error("🔥 [getDocuments] Exception:", e);
    setError("Network error while fetching documents");
    return null;
  }
};
